import tw, { styled } from 'twin.macro';

const formErrorBackground = 'https://storage.googleapis.com/fplsblog/Form_error_images/form_error_background.png';

export const ErrorMessageWrapper = styled.div`
  ${tw`mx-auto my-0 p-8 flex items-center justify-center bg-no-repeat bg-center bg-cover h-screen`};
  box-shadow: 0 0 51px 6px rgb(0 0 0 / 5%);
  background-color: whitesmoke;
  background-image: url(${formErrorBackground});

  & a {
    color: #0b819c;

    :hover {
      text-decoration: underline;
    }
  }

  @media screen and (min-width: 768px) {
    ${tw`p-20`};
  }
`;

export const ErrorContainer = styled.div`
  ${tw`text-center bg-white w-full`};
  background-color: transparent;

  > #exclaim {
    color: #fcb30a;
    font-size: 58px;
    font-weight: 100;
    margin: 0;
  }
`;

export const ErrorHeader = styled.h2`
  ${tw`mx-auto my-0 mb-10 text-center`};
  font-family: Quicksand !important;
  color: #0b819c;

  @media screen and (min-width: 768px) {
    width: 70%;
  }
`;

export const ErrorHeaderSmall = styled(ErrorHeader)`
  font-size: 18px;
  margin-top: 60px;
`;

export const ErrorText = styled.div`
  ${tw`mx-auto my-0 text-center w-full`};
  font-weight: 500;

  & ~ p {
    margin-top: 2rem;
  }

  @media screen and (min-width: 576px) {
    width: 62%;
    font-size: 16px;
  }

  @media screen and (min-width: 1024px) {
    width: 42%;
  }
`;

export const ErrorList = styled.ul`
  ${tw`text-left`};
`;

export const ActionButton = styled.a`
  ${tw`mt-8 py-3 px-11 text-white no-underline inline-block`};
  background: linear-gradient(to left top, #00afbf, #1a8caf);
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  color: white !important;

  &:hover {
    text-decoration: underline;
  }
`;
